/*
  Color specifications
 */

export const colors = {
  common: {
    black: '#222222',
    white: '#fff',
  },
  background: {
    default: '#f8f8f8',
  },
  primary: {
    main: '#536ccd',
    light: '#d7dfff',
  },
  secondary: {
    main: '#006a71',
  },
  grey: {
    100: '#e7e7e7',
    200: '#888888',
    400: '#8b8b8b',
    600: '#555555',
  },
  error: {
    main: '#ef5350',
  },
  warning: {
    main: '#ff7043',
  },
  success: {
    main: '#449c4d',
  },
  text: {
    primary: '#000000',
    secondary: '#4e4e4e',
  },
};
